import React from 'react';
import { IconButton } from '../ui';

function BlogCard({ image, category, title, excerpt }) {
  return (
    <article className="group bg-transparent w-80 flex-shrink-0 snap-center">
      <div className="overflow-hidden rounded-xl shadow-md bg-white border border-am-green-50 hover:shadow-lg hover:border-am-green-100 transition-all duration-300">
        <img src={image} alt={title} className="w-full h-44 object-cover group-hover:scale-105 transition-transform duration-300" />
        <div className="p-5">
          <div className="text-xs text-am-text-700 font-medium uppercase">{category}</div>
          <h3 className="mt-2 text-lg font-semibold text-am-text-900">{title}</h3>
          <p className="mt-3 text-sm text-am-text-700">{excerpt}</p>
          <div className="mt-4 flex items-center">
            <IconButton variant="accent" shape="square" size="sm" className="w-10 h-10" aria-label="Read">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </IconButton>
          </div>
        </div>
      </div>
    </article>
  );
}

export default BlogCard;
